import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/reduce";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import { values } from "lodash";
export const GET_TEMPLATES_CATEGORIES = "GET_TEMPLATES_CATEGORIES";
export const GET_TEMPLATE_BY_ID = "GET_TEMPLATE_BY_ID";
const getters = {
  [GET_TEMPLATES_CATEGORIES]: state => {
    var _context;
    const defaultCategories = ["all", "saved", "predefined"];
    const customCategories = _reduceInstanceProperty(_context = values(state.predefinedTemplates.byId)).call(_context, (acc, {
      category
    }) => {
      if (category && !_includesInstanceProperty(acc).call(acc, category)) acc.push(category);
      return acc;
    }, []);
    return [...defaultCategories, ...customCategories];
  },
  [GET_TEMPLATE_BY_ID]: state => id => {
    return state.userCreated.byId[id] || state.predefinedTemplates.byId[id];
  }
};
export default getters;